/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateSaveCardSession200ResponseAnyOfAmount
 */
export interface CreateSaveCardSession200ResponseAnyOfAmount {
    /**
     * 
     * @type {number}
     * @memberof CreateSaveCardSession200ResponseAnyOfAmount
     */
    value: number;
    /**
     * 
     * @type {string}
     * @memberof CreateSaveCardSession200ResponseAnyOfAmount
     */
    currency: string;
}

/**
 * Check if a given object implements the CreateSaveCardSession200ResponseAnyOfAmount interface.
 */
export function instanceOfCreateSaveCardSession200ResponseAnyOfAmount(value: object): value is CreateSaveCardSession200ResponseAnyOfAmount {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    return true;
}

export function CreateSaveCardSession200ResponseAnyOfAmountFromJSON(json: any): CreateSaveCardSession200ResponseAnyOfAmount {
    return CreateSaveCardSession200ResponseAnyOfAmountFromJSONTyped(json, false);
}

export function CreateSaveCardSession200ResponseAnyOfAmountFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSaveCardSession200ResponseAnyOfAmount {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'currency': json['currency'],
    };
}

export function CreateSaveCardSession200ResponseAnyOfAmountToJSON(json: any): CreateSaveCardSession200ResponseAnyOfAmount {
    return CreateSaveCardSession200ResponseAnyOfAmountToJSONTyped(json, false);
}

export function CreateSaveCardSession200ResponseAnyOfAmountToJSONTyped(value?: CreateSaveCardSession200ResponseAnyOfAmount | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'currency': value['currency'],
    };
}

